import React, { useContext, useState, useEffect } from 'react';

import { HighlightMarker } from '@atoms/highlight-marker';

import { HighlightedAddressState } from '@atlas/types';
import { AtlasEventsContext } from '@atlas/contexts/events';

export const AtlasHighlightMarker = () => {
  const { on } = useContext(AtlasEventsContext);

  const [highlightedAddress, setHighlightedAddress] =
    useState<HighlightedAddressState>();

  useEffect(
    () =>
      on('highlightChange', (highlightedAddress) => {
        setHighlightedAddress(highlightedAddress);
      }),
    [on],
  );

  if (!highlightedAddress) return null;

  return <HighlightMarker coordinates={highlightedAddress.point.coordinates} />;
};
